import React from "react";
import { RENTAL_STATUS } from "./constant";

const getStatus = (record) => {
  if (!record?.status) return "--";

  if (+record.status === RENTAL_STATUS.COMPLETED) {
    return (
      <div className="max-w-max flex items-center px-2 h-7 rounded-md bg-light-grey">
        <p className="font-poppins text-xs font-medium text-dark-gray">
          Completed
        </p>
      </div>
    );
  }

  return (
    <div className="max-w-max flex items-center px-2 h-7 rounded-md bg-yellow">
      <p className="font-poppins text-xs font-medium text-green">Dispatched</p>
    </div>
  );
};

export const statusFilters = () => {
  return [
    {
      id: RENTAL_STATUS.ONGOING,
      value: (
        <div className="max-w-max flex items-center px-2 h-7 rounded-md bg-yellow">
          <p className="font-poppins text-xs font-medium text-green">
            Dispatched
          </p>
        </div>
      ),
    },
    {
      id: RENTAL_STATUS.COMPLETED,
      value: (
        <div className="max-w-max flex items-center px-2 h-7 rounded-md bg-light-grey">
          <p className="font-poppins text-xs font-medium text-dark-gray">
            Completed
          </p>
        </div>
      ),
    },
  ];
};

export default getStatus;
